import React, { Component } from 'react'
import SkuInfo from './SkuInfo'
import SkuSize from './sizes/SkuSize'
import SkuActions from './SkuActions'
import { Card, CardBody } from "reactstrap"
import { editSku, getInfoSku, updateMaterials, getShippingCarrierSku, getProductionProcess, getListBrandSku, getListTab, getListCatalog, getListMaterials } from '../../../services/api/apiSku'
import PropTypes from "prop-types"
import { message, Input } from "antd"
import HistoryPage from "./history/HistoryPage"
import SkuAddCarrier from "./SkuAddCarrier"
import PubSub from "pubsub-js"
import { getLocalData } from "../../../services/StorageServices"
import { parseJwt } from "../../../share/parseToken"
import { getListPartner } from '../../../services/api/3dApi'
import { getListBrandRule, getListBrands } from '../../../services/api/apiBrands'
import SkuAddBrand from './SkuAddBrand'
import { Link } from 'react-router-dom'
import { v4 as uuidV4 } from 'uuid'

class SkuDetailPage extends Component {
    state = {
        name: '',
        sku: '',
        procedure: '2D',
        export_by: '',
        is_active: false,
        flow: '',
        materials: '',
        description: '',
        loading: false,
        error: '',
        validateName: '',
        changeList: [],
        listShipping: [],
        commitment_time: '',
        validateTime: '',
        need_manage_materials: false,
        packed_description: '',
        is_mex: false,
        listPartner: [],
        listProductionProcess: [],
        production_process: '',
        partner: '',
        validatePartner: '',
        meta: '',
        commitment_time_fast_production: '',
        validateTimeFast: '',
        is_embroidery: false,
        embroidery_position: [],
        brandOptions: [],
        listBrand: [],
        listTab: [],
        package_mockup: [],
        is_cut_laze: false,
        list_catalog: [],
        catalog: '',
        is_cheap_product: false,
        is_set: false,
        set_items: [{ name: '' }, { name: '' }],
        sub_materials: [],
        capture_production_file: false,
        embroidery_reusable: true,
        listMaterial: [],
        packed_method: '',
        brands_description_packaged: [
            {
                brand: '',
                description: '',
                images: [],
                isChange: false,
                isLoading: false,
                idx: uuidV4()
            }
        ],
        skuBrands: [],
        listBrandOption: [],
        brandsChecked: []
    }

    _subscription = null

    async componentDidMount() {
        await this._getDetailSku()
        await this._getListBrandRule()
        // this._getShippingCarrier()
        this._getProductProcess()
        this._getPartner()
        this._getMaterial()
        this._getBrandOptions()
        this._getListTab()
        this._getListCatalog()
        // this._getListBrand()
        // this._subscription = PubSub.subscribe('GET_LIST_SHIPPING_CARIER', this._getShippingCarrier)
        // this._subscription = PubSub.subscribe('GET_LIST_BRAND', this._getListBrand)
        this._subscription = PubSub.subscribe('GET_LIST_TAB', this._getListTab)
    }

    _getListCatalog = async () => {
        try {
            const { success, data, message: mess } = await getListCatalog({ page: 1, limit: 10000 })
            if (!success) {
                throw new Error(mess)
            }
            this.setState({
                list_catalog: data.data || []
            })
        } catch (error) {
            console.log(error.message)
        }
    }

    _getListTab = async () => {
        const { id } = this.props
        try {
            const { data } = await getListTab(id)
            const { data: listTab, success } = data

            if (!success) return
            this.setState({
                listTab: listTab
            })
        } catch (e) {
        }
    }

    _getShippingCarrier = async () => {
        const { id } = this.props
        try {
            const { data } = await getShippingCarrierSku(id)
            const { data: listShipping, success } = data
            if (!success) return
            this.setState({
                listShipping
            })
        } catch (e) {
        }
    }

    _getBrandOptions = async () => {
        const payload = {
            page: 1,
            limit: 10000,
        }

        try {
            const { data, success } = await getListBrands(payload)
            const { Brands } = data
            if (!success) return

            const listOption = Brands.map(item => {
                const itemOption = {
                    value: item.name,
                    name: item.name
                }

                return itemOption
            })
            this.setState({
                brandOptions: listOption
            })
        } catch (e) {
        }
    }

    _getListBrand = async () => {
        const { id } = this.props
        try {
            const { data } = await getListBrandSku(id)
            const { data: listBrand, success } = data
            if (!success) return
            this.setState({
                listBrand
            })
        } catch (e) {
        }
    }

    _getMaterial = async () => {
        try {
            const { data: res } = await getListMaterials({ page: 1, limit: 10000 })
            const { data, success } = res
            if (!success) return
            this.setState({ listMaterial: data.data || [] })
        } catch (e) {}
    }

    _getProductProcess = async () => {
        const payload = {
            page: 1,
            limit: 10000,
        }
        try {
            const { data: res } = await getProductionProcess(payload)
            const { data, success } = { ...res }
            const { result } = { ...data }

            if (!success) return
            this.setState({
                listProductionProcess: result
            })
        } catch (e) {
        }
    }

    _getPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success } = await getListPartner(payload)
            const { partners: listPartner } = data
            if (!success) return

            this.setState({
                listPartner
            })
        } catch (e) {
        }
    }

    _handleValidateInfo = () => {
        const { name, commitment_time, partner, commitment_time_fast_production } = this.state

        if (name === '') {
            this.setState({
                validateName: 'Tên SKU là bắt buộc!'
            })

            return false
        } else if (commitment_time === '' || commitment_time === null || +commitment_time < 0) {
            this.setState({
                validateTime: 'Thời gian cam kết là bắt buộc và là số dương!'
            })

            return false
        } else if (+commitment_time_fast_production < 0) {
            this.setState({
                validateTimeFast: 'Thời gian cam kết nhanh phải là số dương!'
            })

            return false
        } else if (partner === '' || partner === null) {
            this.setState({
                validatePartner: 'Bắt buộc chọn partner sản xuất!'
            })

            return false
        } else {
            this.setState({
                validateName: '',
                validateTime: '',
                validatePartner: '',
                validateTimeFast: '',
            })

            return true
        }
    }

    _getDetailSku = async () => {
        const { id } = this.props
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const { data: response } = await getInfoSku(id)
            const { success, data, error } = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            const {
                name, sku, procedure,
                export_by, is_active, meta,
                flow, materials, description,
                commitment_time, need_manage_materials,
                packed_description, is_mex, partner,
                commitment_time_fast_production, is_embroidery, embroidery_info,
                production_process, package_mockup = [], is_cut_laze, is_cheap_product, catalog = {},
                is_set, set_items = [{ name: '' }, { name: '' }], packed_method = '', brands_description_packaged = [], sku_brands = [],
                sub_materials = [],
                capture_production_file = false,
                embroidery_reusable
            } = data

            const { embroidery_position } = Object.assign({}, embroidery_info)
            const embroideryPositionArray = !!embroidery_position && Object.entries(embroidery_position).map(([key, value]) => ({
                side: key,
                order: value.order
            }))

            const newBrandsDescriptionPackaged = !!brands_description_packaged.length && brands_description_packaged.every(i => (!!i.brand && !!i.description)) ?
                brands_description_packaged.map(i => ({
                    brand: !!i.brand ? i.brand : '',
                    description: !!i.description ? i.description : '',
                    images: !!i.images ? i.images : [],
                    isChange: false,
                    isLoading: false,
                    idx: uuidV4()
                })) : [
                    {
                        brand: '',
                        description: '',
                        images: [],
                        isChange: false,
                        isLoading: false,
                        idx: uuidV4()
                    }
                ]

            this.setState({
                loading: false,
                error: '',
                flow: flow || '',
                materials: materials || '',
                description: description || '',
                name,
                sku,
                procedure,
                export_by,
                is_active,
                commitment_time,
                need_manage_materials,
                packed_description,
                is_mex,
                partner: partner ? partner.id : '',
                meta: meta,
                commitment_time_fast_production,
                is_embroidery,
                embroidery_position: embroideryPositionArray.length > 0 ? embroideryPositionArray : [{ side: '', order: 1 }],
                production_process: production_process ? production_process._id : '',
                package_mockup,
                is_cut_laze,
                is_cheap_product,
                catalog: catalog._id || '',
                is_set,
                set_items: Array.isArray(set_items) && set_items.length > 0 ? set_items : [{ name: '' }, { name: '' }],
                packed_method,
                brands_description_packaged: newBrandsDescriptionPackaged,
                skuBrands: sku_brands,
                sub_materials: Array.isArray(sub_materials) ? sub_materials : (sub_materials ? [sub_materials] : []),
                capture_production_file: !!capture_production_file,
                // BE coi SKU không có field embroidery_reusable là cho phép reuse → chỉ false mới là tắt
                embroidery_reusable: embroidery_reusable !== false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }

    }

    _handleChangeInfo = (name, value) => {
        if (name === "commitment_time_fast_production") {
            const reg = /^-?\d*(\.\d*)?$/
            if (reg.test(value) || value === '' || value === '-') {
                this.setState({
                    [name]: value
                }, () => {
                    const checking = this._handleValidateInfo()

                    if (checking) {
                        const { changeList } = this.state
                        const change = changeList.includes(name)

                        if (changeList.length === 0 || !change) {
                            this.setState({
                                changeList: [...changeList, name]
                            })
                        }
                    }
                })
            }
        } else {
            this.setState({
                [name]: name === 'materials' ? (typeof value === 'string' && value.toUpperCase()) : value
            }, () => {
                const checking = this._handleValidateInfo()

                if (checking) {
                    const { changeList } = this.state
                    const change = changeList.includes(name)

                    if (changeList.length === 0 || !change) {
                        this.setState({
                            changeList: [...changeList, name]
                        })
                    }
                }
            })
        }
    }

    _onUpdateSku = async () => {
        const {
            name, procedure, export_by,
            is_active, flow, description,
            commitment_time, need_manage_materials,
            packed_description, is_mex, partner,
            commitment_time_fast_production, embroidery_position, is_embroidery,
            production_process, package_mockup, is_cut_laze, is_cheap_product, catalog,
            is_set, set_items, packed_method, brands_description_packaged, brandsChecked, listBrandOption,
            sub_materials,
            capture_production_file,
            embroidery_reusable
        } = this.state
        const { id } = this.props
        const embroidery_position_payload = embroidery_position.filter(i => i.side).reduce((arr, item) => {
            if (Object.keys(arr).includes(!!item.side && item.side.trim())) return {
                err: 'Vị trí thêu không được trùng nhau.'
            }
            arr[item.side] = {
                order: item.order
            }
            return arr
        }, {})

        if (this._handleValidateInfo()) {
            this.setState({
                loading: true,
                error: ''
            })

            try {
                const payload = {
                    procedure: !!procedure ? procedure : '2D',
                    flow: !!flow ? flow : '',
                    description: description,
                    name,
                    export_by,
                    is_active,
                    commitment_time,
                    need_manage_materials,
                    packed_description,
                    is_mex, partner,
                    commitment_time_fast_production,
                    is_embroidery,
                    production_process,
                    package_mockup,
                    is_cut_laze,
                    is_cheap_product,
                    catalog,
                    is_set,
                    packed_method,
                    sub_materials: Array.isArray(sub_materials) ? sub_materials : [],
                    capture_production_file,
                    embroidery_reusable: embroidery_reusable !== false,
                }

                if (is_embroidery) {
                    if (!!embroidery_position_payload.err) {
                        this.setState({
                            loading: false
                        })
                        return { error: embroidery_position_payload.err }
                    }
                    payload.embroidery_position = embroidery_position_payload
                }

                if (is_set) {
                    payload.set_items = set_items
                }

                if(!!brands_description_packaged.length && brands_description_packaged.every(i => (!!i.brand && !!i.description))){
                    const newBrandsDescriptionPackaged = brands_description_packaged.map(b => {
                        const {idx, isChange, isLoading, ...rest} = Object.assign({}, b)
                        return rest
                    }) || []

                    payload.brands_description_packaged = newBrandsDescriptionPackaged
                }

                const sku_brands = listBrandOption.map(option => {
                    const itemBrand = {
                        "brand": option.label,
                        "is_ready": brandsChecked.includes(option.value)
                    }

                    return itemBrand
                })

                if(sku_brands.length > 0){
                    payload.sku_brands = sku_brands
                }

                const { data: response } = await editSku(id, payload)
                const { success, message: error } = response

                if (!success) {
                    this.setState({
                        loading: false,
                    })
                    return { error }
                }

                this.setState({
                    loading: false,
                    error: ''
                })
            } catch (e) {
                this.setState({
                    loading: false,
                    error: e.message
                })
            }
        }
    }

    validateSetItems = (items) => {
        if (!Array.isArray(items)) return false

        let valid = true

        const newItems = items.map(item => {
            const name = (item.name || '').toString()
            const trimmed = name.trim()
            const errors = []

            if (trimmed.length === 0) {
                errors.push('Không được để trống hoặc chỉ chứa khoảng trắng')
            }
            if (trimmed.length > 100) {
                errors.push('Tối đa 100 ký tự')
            }

            const newItem = { ...item }

            if (errors.length) {
                newItem.error = errors.join(' ')
                valid = false
            } else {
                delete newItem.error

                newItem.name = trimmed
            }

            return newItem
        })
        this.setState({ set_items: newItems })
        return valid
    }

    _onUpdateMaterials = async () => {
        const { materials } = this.state
        const { id } = this.props

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                materials
            }

            const { data: response } = await updateMaterials(id, payload)
            const { success, message: error } = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                error: ''
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleClickUpdate = async (e) => {
        e.preventDefault()

        const { changeList, set_items, is_set } = this.state
        const request = []
        const changeSku = changeList.filter(item => !['materials'].includes(item))
        if (is_set && !this.validateSetItems(set_items)) return
        if (changeList.includes('materials')) {
            request.push(this._onUpdateMaterials())
        }

        if (changeSku.length > 0) {
            request.push(this._onUpdateSku())
        }

        if (request.length) {
            const data = await Promise.all(request) || []
            if (data.some(i => !!i && !!i.error)) {
                const err = data.find(i => !!i && !!i.error)
                return message.error(err.error)
            }
            await this._getDetailSku()
            message.success('Cập nhật thông tin thành công.')
            PubSub.publish('GET_HISTORY')
        }

        this.setState({
            changeList: [],
        })
    }

    hanldeAddConfigEmbroidery = (order) => {
        const { embroidery_position } = this.state
        const itemEmbroidery = embroidery_position.length > 0 ? embroidery_position.find(i => i.order === order) : {}
        if ((!!itemEmbroidery && !itemEmbroidery.side) || embroidery_position.length > 49) return
        this.setState({
            embroidery_position: [
                ...embroidery_position,
                {
                    side: '',
                    order: order + 1
                }
            ]
        }, () => {
            const { changeList } = this.state
            const change = changeList.includes('embroidery_position')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'embroidery_position']
                })
            }
        })
    }

    hanldeDeleteConfigEmbroidery = (order) => {
        const { embroidery_position } = this.state
        const newEmbroideryPosition = embroidery_position.map(i => {
            if (i.order !== order) {
                return {
                    ...i,
                    order: i.order <= order ? i.order : i.order - 1
                }
            }
        }).filter(Boolean)
        this.setState({
            embroidery_position: newEmbroideryPosition
        }, () => {
            const { changeList } = this.state
            const change = changeList.includes('embroidery_position')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'embroidery_position']
                })
            }
        })
    }

    hanldeChangeEmbroidery = (value, order) => {
        const { embroidery_position } = this.state
        const newEmbroideryPosition = embroidery_position.map(i => {
            if (i.order === order) {
                return {
                    ...i,
                    side: value
                }
            }
            return i
        })
        this.setState({
            embroidery_position: newEmbroideryPosition
        }, () => {
            const { changeList } = this.state
            const change = changeList.includes('embroidery_position')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'embroidery_position']
                })
            }
        })
    }

    hanldeMakeEmbroidery = () => {
        const { embroidery_position } = this.state
        const newEmbroideryPosition = embroidery_position.filter(i => !!i.side)
        this.setState({
            embroidery_position: newEmbroideryPosition.length > 0 ? newEmbroideryPosition : [{ side: '', order: 1 }]
        })
    }

    handleAddImageDescribe = (imageUrl) => {
        const { package_mockup = [] } = this.state
        this.setState({
            package_mockup: [...package_mockup, imageUrl]
        }, () => {
            const checking = this._handleValidateInfo()

            if (checking) {
                const { changeList } = this.state
                const change = changeList.includes("package_mockup")

                if (changeList.length === 0 || !change) {
                    this.setState({
                        changeList: [...changeList, "package_mockup"]
                    })
                }
            }
        })
    }

    handleRemoveImageDescribe = (imageUrl) => {
        const { package_mockup = [] } = this.state
        const newPackageMockup = package_mockup.filter((item) => item !== imageUrl)
        this.setState({
            package_mockup: newPackageMockup
        }, () => {
            const checking = this._handleValidateInfo()

            if (checking) {
                const { changeList } = this.state
                const change = changeList.includes("package_mockup")

                if (changeList.length === 0 || !change) {
                    this.setState({
                        changeList: [...changeList, "package_mockup"]
                    })
                }
            }
        })
    }

    _handleChangeSubMaterials = (value) => {
        this.setState({ sub_materials: value }, () => {
            const { changeList } = this.state
            if (!changeList.includes('sub_materials')) {
                this.setState({ changeList: [...changeList, 'sub_materials'] })
            }
        })
    }

    _handleChangeBrandsDescriptionPackaged = (data) => {
        this.setState({brands_description_packaged: data})
    }

    _getListBrandRule = async () => {
        const {sku} = this.state

        this.setState({
            loading: true,
            error: ''
        })

        try {

            const payload = {
                page: 1,
                limit: 1000
            }
            const query = {
                product_type: sku,
                status: true
            }
            
            if (Object.keys(query).length > 0) payload.query = query
            
            const { data } = await getListBrandRule(payload)
            const { success, message: mess, data: res } = data

            if (!success) {
                return this.setState({
                    loading: false,
                    error: mess
                })
            }

            const { brand_rule } = res
            
            const uniqueBrands = brand_rule.length > 0 ? Object.values(
                brand_rule.reduce((acc, rule) => {
                    const brand = rule.brand;
                    if (brand && !acc[brand._id]) {
                    acc[brand._id] = brand;
                    }
                    return acc;
                }, {})
            ) : []
            
            const listBrandOption = uniqueBrands.length > 0 ? uniqueBrands.map((brandItem, index) => {
                const option = {
                    label: brandItem.name ? brandItem.name : '',
                    value: brandItem._id,
                    className: `brandRule-${index}`
                }

                return option
            }) : []

            this.setState({
                loading: false,
                error: '',
                listBrandOption
            }, () => {
                const {listBrandOption, skuBrands} = this.state
                let initBrandChecked = []
                if(skuBrands.length > 0){
                    initBrandChecked = listBrandOption.filter(option =>
                        skuBrands.some(
                            sku => sku.brand === option.label && sku.is_ready === true
                        )
                    )
                    .map(option => option.value)
                }

                this.setState({
                    brandsChecked: initBrandChecked
                })
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }

    }

    handleChangeBrandReady = checkedValues => {
        this.setState({
            brandsChecked: checkedValues
        }, () => {
            const { changeList } = this.state
            const change = changeList.includes('brands_ready')

            if (changeList.length === 0 || !change) {
                this.setState({
                    changeList: [...changeList, 'brands_ready']
                })
            }
        })
    };

    render() {
        const { id } = this.props
        const {
            loading,
            error,
            name,
            sku,
            procedure,
            export_by,
            is_active,
            flow,
            materials,
            description,
            validateName,
            changeList,
            commitment_time,
            validateTime,
            need_manage_materials,
            packed_description,
            is_mex,
            listPartner,
            partner,
            validatePartner,
            meta,
            commitment_time_fast_production,
            validateTimeFast,
            is_embroidery,
            embroidery_position,
            listProductionProcess,
            production_process,
            brandOptions,
            listTab,
            package_mockup,
            is_cut_laze,
            is_cheap_product,
            list_catalog, catalog,
            is_set, set_items, packed_method,
            brands_description_packaged,
            brandsChecked,
            listBrandOption,
            sub_materials,
            capture_production_file,
            embroidery_reusable,
            listMaterial
        } = this.state
        const token = getLocalData('accessToken')
        const user = token !== '' && parseJwt(token).permissions ? parseJwt(token).permissions : {}
        const isFFMView = user.hasOwnProperty('base_cost_management')

        return (
            <div className="SkuDetailPage">
                <Card>
                    <div className="CardHeader card-header header-elements-inline">
                        <h1 className='card-title font-weight-bold d-flex align-items-center'>
                            <Link to={'/sku-manager'} className="txt-16"><i className="fa fa-chevron-left mr-2 mt-2" /></Link>
                            Sửa sản phẩm - {sku}
                        </h1>
                        {error && <div className="mt-3 text-danger">{error}</div>}
                    </div>

                    <CardBody>
                        <SkuInfo
                            skuID={id}
                            loading={loading}
                            packageMockup={package_mockup}
                            error={error}
                            validateName={validateName}
                            validateTime={validateTime}
                            validatePartner={validatePartner}
                            name={name}
                            sku={sku}
                            procedure={procedure}
                            export_by={export_by}
                            is_active={is_active}
                            flow={flow}
                            materials={materials}
                            description={description}
                            commitment_time={commitment_time}
                            onChange={this._handleChangeInfo}
                            need_manage_materials={need_manage_materials}
                            packed_description={packed_description}
                            is_mex={is_mex}
                            listPartner={listPartner}
                            partner={partner}
                            meta={meta}
                            commitment_time_fast_production={commitment_time_fast_production}
                            is_embroidery={is_embroidery}
                            onMakeEmbroidery={this.hanldeMakeEmbroidery}
                            listProductionProcess={listProductionProcess}
                            production_process={production_process}
                            onAddImageDescribe={this.handleAddImageDescribe}
                            onRemoveImageDescribe={this.handleRemoveImageDescribe}
                            is_cut_laze={is_cut_laze}
                            is_cheap_product={is_cheap_product}
                            list_catalog={list_catalog}
                            catalog={catalog}
                            is_set={is_set}
                            set_items={set_items}
                            packed_method={packed_method}
                            brandOptions={brandOptions || []}
                            brandsDescriptionPackaged={brands_description_packaged}
                            onChangeBrandsDescriptionPackaged={this._handleChangeBrandsDescriptionPackaged}
                            actionUpdate={this._onUpdateSku}
                            getDetailSku={this._getDetailSku}
                            listBrandOption={listBrandOption}
                            brandsChecked={brandsChecked}
                            onchangeBrandReady={this.handleChangeBrandReady}
                            sub_materials={sub_materials}
                            onChangeSubMaterials={this._handleChangeSubMaterials}
                            listMaterial={listMaterial}
                            capture_production_file={capture_production_file}
                            embroidery_reusable={embroidery_reusable}
                        />

                        {
                            is_embroidery &&
                            <div className="embroidery-priority w-50 mb-3 p-3" style={{ border: '1px solid', borderRadius: 10 }}>
                                <h4 className='font-weight-bold'>Vị trí thêu và độ ưu tiên</h4>
                                {
                                    embroidery_position.length > 0 && (
                                        <div className="embroidery-priority-items">
                                            {
                                                embroidery_position.sort((a, b) => a.order - b.order).map((item, i) => (
                                                    <div className="embroidery-priority-item my-2" key={`${item}_${i}`}>
                                                        <div className='label-item'>Vị trí {item.order}</div>
                                                        <Input
                                                            style={{ width: 300 }}
                                                            value={item.side}
                                                            onChange={(e) => this.hanldeChangeEmbroidery(e.target.value, item.order)}
                                                        />
                                                        {i > 0 && <i className="icon-bin text-danger cursor-pointer ml-2" onClick={() => this.hanldeDeleteConfigEmbroidery(item.order)} />}
                                                        {i === embroidery_position.length - 1 && <i className="icon-plus-circle2 text-success cursor-pointer ml-2" onClick={() => this.hanldeAddConfigEmbroidery(item.order)} />}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        }

                        <div className="d-flex justify-content-between align-items-center info-detail-head">
                            <h3 className="font-weight-bold">Thông tin chi tiết</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <SkuAddBrand skuID={id} brandOptions={brandOptions} listTab={listTab} />
                                <SkuAddCarrier skuID={id} listTab={listTab} />
                            </div>
                        </div>

                        <SkuSize skuID={id} isFFMView={isFFMView} brandOptions={brandOptions} listTab={listTab} />

                        <SkuActions
                            changeList={changeList}
                            commitmentTime={commitment_time}
                            validateName={validateName}
                            validateTime={validateTime}
                            validatePartner={validatePartner}
                            loading={loading}
                            actionUpdate={this._handleClickUpdate}
                            validateTimeFast={validateTimeFast}
                            embroideryPosition={embroidery_position}
                            isEmbroidery={is_embroidery}
                        />

                        <hr />

                        <HistoryPage id={id} />
                    </CardBody>
                </Card>
            </div>
        )
    }
}

SkuDetailPage.propTypes = {
    id: PropTypes.string.isRequired,
}

export default SkuDetailPage
